declare var swal: any;

import { Component, ViewChild, AfterViewInit, OnInit, AfterViewChecked, Input } from '@angular/core';
import { TurtleService } from '../services/turtle.service';
import { ColorService } from '../services/color.service';
import { LanguageService } from '../services/language.service';
import { CommandsService } from '../services/commands.service';
import { CanvasService } from '../services/canvas.service';
import { BlocksService } from '../services/blocks.service';
import { BluetoothService } from '../services/bluetooth.service';

@Component({
  selector: 'app-canvas',
  templateUrl: './canvas.component.html'
})

export class CanvasComponent {

  @Input('commandsServiceMaster') commandsService: CommandsService;
  @Input('turtleServiceMaster') turtle: TurtleService;
  @Input('canvasServiceMaster') canvasService: CanvasService;
  @Input('blocksServiceMaster') blocks: BlocksService;
  @Input('bluetoothServiceMaster') bluetoothService: BluetoothService;

  // variables related to the canvas itself
  private width: number;
  private height: number;
  private canvascontainer;

  // Internal readjustmens
  //private readonly STROKE_LENGTH_MULTIPLIER = 1 / 1.8;
  static readonly STROKE_LENGTH_MULTIPLIER = 1 / 1.8;
  static MULTIPLIER;
  static readonly TURTLE_SIZE_MULTIPLIER = 0.4;

  //.how the turtles look
  static img: HTMLImageElement;

  // variables related to canvas moving
  private isActive = false;
  private startDragX: number;
  private startDragY: number;
  private turtleImgLocation = 'app/img/turtles/turtle0.png';
  static updateDimension;

  static stop = false;

  // Function that's used as a callback for turtle image changes by the header component.
  static turtleImgLoadFunction;


  //Logging
  static aufgabe = 1;
  static startTime;

  @ViewChild('b') backgroundCanvas;
  @ViewChild('d') drawCanvas;
  @ViewChild('t') turtleCanvas;

  // TODO: this can be removed right?
  private praises = ["Klasse Job!", "Brillante Arbeit! Danke!!!", "Ich bin echt stolz auf dich.", "Wow! Ich hatte keine Ahnung wie gut du bist.", "Daumen hoch.", "Ganz ehrlich: Anfangs war ich mir nicht sicher. Aber du hast alle Erwartungen weit, weit übertroffen.", "Phantastisches Ergebnis. Ich gratuliere!", "Das ist grossartig!", "Deine Lösung ist genial!", "Das ist sehr gut geworden - Bravo!", "Toll!", "Jetzt hast du es erfasst.", "Was ich sehe, ist perfekt, akurat, komplett durchdacht, puenktlich in der Zeit - Gut gemacht!", "Wie immer: phantastische Arbeit!", "Und ich dachte schon, du kannst dich nicht mehr steigern... Mein Fehler!", "Du bist ein guter Denker.", "Ein Meisterstueck - vor allem in der Kuerze der Zeit!", "Ich muss das noch mal sagen: Du hast da wirklich erstklassige Arbeit geleistet!", "Wunderbar, genau das habe ich mir als Ergebnis gewuenscht!", "Mensch bist du gut! Das ist jetzt mehr, als man erwarten konnte...", "Auf dich kann man zaehlen - immer und immer wieder!", "Glückwunsch", "Du bist ein Superstar", "... und das Problem ist gelöst. Grossartige Arbeit", "Du kannst stolz auf dich sein", "Sensationell!", "Du bist der Beste", "das war nicht einfach, aber du hast es geschafft.", "Nichts kann dich jetzt noch stoppen", "Du machst grosse Fortschritte", "Ich wusste, du würdest es hinbekommen", "Fantastisch!", "Ich kann nur sagen: Wow, das ist wirklich gut!", "Ich mag es, wie du denkst", "Ausgezeichnet, wie du das hinbekommen hast!", "Du bist sehr kreativ", "Zeig uns, was du kannst!", "Mit Vollgas voraus.", "Du bist nicht mehr zu bremsen"];

  constructor(private lang: LanguageService) {
    document.onmouseup = function () {
      this.isActive = false;
    }.bind(this);
  }

  // Creates and returns a deep clone of a state
  public deepCloneState(state) {
    const data = state[1];
    const dataCopy = JSON.parse(JSON.stringify(data));

    const turtle = state[0];
    const turtleCopy = new TurtleService();
    for (const key in turtle) {
      if (turtle.hasOwnProperty(key)) {
        turtleCopy[key] = turtle[key];
      }
    }

    const stateCopy = new Array();
    stateCopy.push(turtleCopy);
    stateCopy.push(dataCopy);

    return stateCopy;
  }

  // Create copies of turtle and canvas to return to debugger
  public getState() {
    const state = new Array();
    state.push(this.turtle);
    state.push(this.canvasService.getImageData());

    return this.deepCloneState(state);
  }

  // Restores state of canvas and turtle
  public restoreState(state) {
    const imageData = state.pop();
    const turtle = state.pop();
    this.canvasService.setImageData(imageData);
    this.turtle = turtle;
    this.flush();
  }

  flush() {
    //TODO
    this.canvasService.flushCanvas(this.turtle);
  }

  // used when computation takes too long, interruption from user
  stopSet() {
    return CanvasComponent.stop;
  }

  // set canvas not to be moveable manually
  setInactive(e: MouseEvent) {
    this.isActive = false;
  }

  // set canvas to be moveable manually
  setActive(e: MouseEvent) {
    // determine positioning of canvas in the window at the moment
    let element = document.getElementById('canvasD');
    let rect = element.getBoundingClientRect();
    this.startDragX = e.clientX;
    this.startDragY = e.clientY;
    // set canvas to be moveable
    this.isActive = true;
  }

  // Detect window resize and adjust dimensions accordingly
  onWindowResize(e: Event) {
    CanvasComponent.updateDimension();
  }

  // perform dragging on canvas
  draggingCanvas(e: MouseEvent) {
    if (this.isActive) {
      let dragDeltaX = e.clientX - this.startDragX;
      let dragDeltaY = e.clientY - this.startDragY;
      this.startDragX = e.clientX;
      this.startDragY = e.clientY;
      // TODO: I think it would be possible for the delta to become an incorrect value if the user resizes the window *while* dragging. This can
      // happen if he fullscreens the application with a keyboard shortcut
      this.canvasService.clearTurtle(this.turtle);
      this.canvasService.dragCanvas(-dragDeltaX, -dragDeltaY);
      this.canvasService.drawTurtle(this.turtle);
    }
  }


  ngOnInit() {

    if (this.blocks.isBlockMode()) {
      this.canvascontainer = document.getElementById('canvascontainer');
      this.canvascontainer.classList.add('canvascontainerBlocks');
      this.canvascontainer.classList.remove('canvascontainer');
    }

    CanvasComponent.MULTIPLIER = CanvasComponent.STROKE_LENGTH_MULTIPLIER;

    CanvasComponent.updateDimension = function () {
      let canvasD = <HTMLCanvasElement>document.getElementById('canvasD');
      let canvasT = <HTMLCanvasElement>document.getElementById('canvasT');

      canvasD.width = canvasD.offsetWidth;
      canvasD.height = canvasD.offsetHeight;
      canvasT.width = canvasT.offsetWidth;
      canvasT.height = canvasT.offsetHeight;

      // Adjust canvas size internally
      this.canvasService.setCanvasDimension(canvasD.width, canvasD.height);

      // Changing size properties of canvas leads to clearing, need to draw again
      this.flush();
    }.bind(this);

    //load turtle image.
    CanvasComponent.turtleImgLoadFunction = function () {
      let scaledWidth = CanvasComponent.img.width * CanvasComponent.TURTLE_SIZE_MULTIPLIER;
      let scaledHeight = scaledWidth * (CanvasComponent.img.height / CanvasComponent.img.width);
      CanvasComponent.img.width = scaledWidth;
      CanvasComponent.img.height = scaledHeight;

      this.canvasService.flushCanvas(this.turtle);
    }.bind(this);
  }

  ngAfterViewInit() {
    // prepare canvas (reset all variables, set turtle, its position and orientation)
    this.load();
  }

  ngAfterViewChecked() {
    // recognize resize and change canvas width accordingly
    /*
    if (document.getElementById('container').offsetWidth !== this.width) {
      setTimeout(() => {
        this.width = document.getElementById('container').offsetWidth;
        this.height = document.getElementById('container').offsetHeight;
        this.reload();
      }, 1);
    }

    // offscreen rendering: create offscreen canvas, width and hight changed
    CanvasComponent.offscreenCanvas = document.createElement('canvas');
    CanvasComponent.offscreenCanvas.width = this.width * 3;
    CanvasComponent.offscreenCanvas.height = this.height * 3;
    this.canvasService.contextOffscreen = CanvasComponent.offscreenCanvas.getContext('2d');
    this.canvasService.contextOffscreen.moveTo(this.width, this.height);

    // apply all changes also to the offscreen canvas
    this.canvasService.contextOffscreen.fillRect(20 + this.width, 20 + this.height, 100, 100);
    this.canvasService.contextOffscreen.moveTo(this.width + this.turtle.getX(), this.height + this.turtle.getY());
    this.canvasService.contextOffscreen.lineTo(this.turtle.getX() + this.width - 100, this.turtle.getY() + this.height - 100);
    this.canvasService.contextOffscreen.stroke();
    */
    //TODO: Can this be left disabled?
  }

  // prepare canvas
  private load() {

    this.width = this.canvascontainer.offsetWidth;
    this.height = this.canvascontainer.offsetHeight;

    this.canvasService.contextBackground = this.backgroundCanvas.nativeElement.getContext('2d');
    this.canvasService.contextDraw = this.drawCanvas.nativeElement.getContext('2d');
    this.canvasService.contextTurtle = this.turtleCanvas.nativeElement.getContext('2d');

    this.canvasService.initializeCanvas(this.width, this.height);

    // load turtle picture
    CanvasComponent.img = new Image();
    CanvasComponent.img.src = this.turtleImgLocation;
    CanvasComponent.img.addEventListener('load', CanvasComponent.turtleImgLoadFunction);

    //draw turtle at rigth location on canvas
    this.turtle.reset(this.canvasService.getViewedRegionCenterX(), this.canvasService.getViewedRegionCenterY(), true);
    this.turtle.startX = this.canvasService.getViewedRegionCenterX();
    this.turtle.startY = this.canvasService.getViewedRegionCenterY();

    // display turtle
    this.canvasService.storeTurtleInfoForFlush(this.turtle);

  }

  // reload canvas. used when canvas changes, window resize
  private reload() {
    // TODO: Remove this method entirely? This is only used in afterViewChecked, which is currently commented out
    this.turtle.setX(this.width / 2);
    this.turtle.setY(this.height / 2);
    this.canvasService.drawTurtle(this.turtle);
  }

  // Move a turtle a certain distance
  private move(distance: number) {
    // Calculate the turtle position after moving.

    //distance *= this.STROKE_LENGTH_MULTIPLIER;
    distance *= CanvasComponent.MULTIPLIER;
    var oldX = this.turtle.getX();
    var oldY = this.turtle.getY();
    this.turtle.setX(oldX + distance * Math.sin(Math.PI / 180 * this.turtle.getDirection()));
    this.turtle.setY(oldY - distance * Math.cos(Math.PI / 180 * this.turtle.getDirection()));

    if (this.turtle.getPenDown()) {
      this.canvasService.makeTurtleStroke(oldX, oldY, this.turtle.getX(), this.turtle.getY(), this.turtle.getPenColor(), this.turtle.getPenWidth());
    }
  }



  // #########################################################################################################################################
  //
  // library functions for XLogo commands, those are called from the visitor
  //
  // #########################################################################################################################################

  next() {

    /*
     switch(document.getElementById("aufgabe").innerHTML){
       case "Aufgabe 2": document.getElementById("aufgabe").innerHTML = "Aufgabe 3a"; CanvasComponent.aufgabe = 3; break;
       case "Aufgabe 3a": document.getElementById("aufgabe").innerHTML = "Aufgabe 3b"; break;
       case "Aufgabe 3b": document.getElementById("aufgabe").innerHTML = "Aufgabe 3c"; break;
       case "Aufgabe 3c": document.getElementById("aufgabe").innerHTML = "Aufgabe 3d"; break;
       case "Aufgabe 9": document.getElementById("aufgabe").innerHTML = "Aufgabe 10a"; CanvasComponent.aufgabe = 10; break;
       case "Aufgabe 10a": document.getElementById("aufgabe").innerHTML = "Aufgabe 10b";break;
       case "Aufgabe 10b": document.getElementById("aufgabe").innerHTML = "Aufgabe 10c";break;
       case "Aufgabe 10c": document.getElementById("aufgabe").innerHTML = "Aufgabe 11a"; CanvasComponent.aufgabe = 11; break;
       case "Aufgabe 11a": document.getElementById("aufgabe").innerHTML = "Aufgabe 11b";break;
       case "Aufgabe 11b": document.getElementById("aufgabe").innerHTML = "Aufgabe 12a"; CanvasComponent.aufgabe = 12; break;
       case "Aufgabe 12a": document.getElementById("aufgabe").innerHTML = "Aufgabe 12b";break;
       default: CanvasComponent.aufgabe++; document.getElementById("aufgabe").innerHTML = "Aufgabe "+CanvasComponent.aufgabe.toString();
     }
     */

    var praisesIndex = Math.floor(Math.random() * this.praises.length);
    swal("weiter so!", this.praises[praisesIndex], "success");
  }

  last() {
    /*
    if(CanvasComponent.aufgabe > 1){
      CanvasComponent.aufgabe--;
      document.getElementById("aufgabe").innerHTML = "Aufgabe "+CanvasComponent.aufgabe.toString();
    }
    */
  }

//command GO added after pressing "ENTER" to be able to communicate with Bluetooth devices
  //Send a sequence of commands to device
  go() {
    if (this.bluetoothService.checkWhetherBluetoothConnected()) {
      this.bluetoothService.go();
    }
  }

  //command wait added to be able to send it to BlueBot.
  //This will only be executed when a BlueBot is connected
  wait() {
    if (this.bluetoothService.checkWhetherBluetoothConnected()) {
      this.bluetoothService.wait();
    }
  }

  fd(distance) {
    this.move(distance);

    //used to navigate bluetooth device
    //only executed if bluetooth device connected
    //if statement checks for forward or backward commands
    if (distance > 0) {
      if (this.bluetoothService.checkWhetherBluetoothConnected()) {
        this.bluetoothService.moveForward();
      }
    }
    else if (distance < 0) {
      if (this.bluetoothService.checkWhetherBluetoothConnected()) {
        this.bluetoothService.moveBack();
      }
    }
  }

  bk(distance) {
    this.move(-distance);
  }

  rt(deg) {
    this.turtle.setDirection(this.turtle.getDirection() + deg);

    //used to navigate bluetooth device
    //only executed if bluetooth device connected
    //divides to 45 and 90 degrees
    if (this.bluetoothService.checkWhetherBluetoothConnected()) {
      if (deg == 45) {
        this.bluetoothService.moveRight45();
      } else {
        this.bluetoothService.moveRight90();
      }
    }

  }

  lt(deg) {
    this.turtle.setDirection(this.turtle.getDirection() - deg);

    //used to navigate bluetooth device
    //only executed if bluetooth device connected
    //divides to 45 and 90 degrees
    if (this.bluetoothService.checkWhetherBluetoothConnected()) {
      if (deg == 45) {
        this.bluetoothService.moveLeft45();
      } else {
        this.bluetoothService.moveLeft90();
      }
    }
  }
  pu() {
    this.turtle.setPenVisible(false);
  }

  pd() {
    this.turtle.setPenVisible(true);
  }

  st() {
    this.turtle.setTurtleVisible(true);
  }

  ht() {
    this.turtle.setTurtleVisible(false);
  }

  ct() {
    this.commandsService.deleteAll();
    this.commandsService.removeAllCommandFromHistory();
  }

  cs() {
    this.turtle.setPenColor(new ColorService('black'));
    this.canvasService.clearScreen();
    this.turtle.reset(this.canvasService.getViewedRegionCenterX(), this.canvasService.getViewedRegionCenterY(), true);
  }

  pe() {
    this.turtle.setErasing(true, this.canvasService.getBackgroundColor());
  }

  ppt() {
    this.turtle.setErasing(false, this.canvasService.getBackgroundColor());
  }

  setpw(width: number) {
    if (width >= 1) {
      this.turtle.setPenWidth(width);
    } else {
      this.print(this.lang.getLang()['tooSmall']);
    }
  }

  wash() {
    this.canvasService.washCanvas();
  }

  getColor(arg: any): ColorService {
    return new ColorService(arg);
  }

  setscreencolor(color: ColorService) {
    this.canvasService.changeScreenColor(color);
  }

  setpencolor(color: ColorService) {
    this.turtle.setPenColor(color);
  }

  setxy(x: number, y: number) {
    //Note: the turtle's position is always centered in the middle of the underlying bitmap.
    //So if we want to change the coordinates (here they are given as additive difference to the acutal underlying coordinated), we need to translate it accordingly.
    this.turtle.setX(x+this.turtle.startX);
    this.turtle.setY(-y+this.turtle.startY);
  }

  setx(x: number) {
    this.setxy(x, this.turtle.getY()-this.turtle.startY);
  }

  sety(y: number) {
    this.setxy(this.turtle.getX()-this.turtle.startX, y);
  }

  home() {
    this.turtle.reset(this.canvasService.getViewedRegionCenterX(), this.canvasService.getViewedRegionCenterY(), false);
  }

  circle(radius: number) {
    //radius *= this.STROKE_LENGTH_MULTIPLIER;
    radius *= CanvasComponent.MULTIPLIER;
    if (this.turtle.getPenDown()) {
      this.canvasService.makeTurtleCircle(radius, this.turtle.getX(), this.turtle.getY(), this.turtle.getPenColor(), this.turtle.getPenWidth());
    }
  }

  print(text: string) {
    this.commandsService.addString(text);
  }

  reportError(errormessages: string[], input: string) {
    this.commandsService.addErrorMessage(errormessages, input);
  }

  setheading(direction: number) {
    this.turtle.setDirection(direction);
  }

}

// vim: shiftwidth=2



// WEBPACK FOOTER //
// ./src/app/components/canvas.component.ts